export default {
  CLICK_TOKEN: 'ClickToken',
  CLICK_MORE: 'ClickMore',
  CLICK_SORT: 'ClickSort'
};
